import { Combobox, ComboboxInput, ComboboxButton, ComboboxOptions, ComboboxOption } from '@headlessui/react';
import { ChevronDownIcon } from '@heroicons/react/20/solid';
import { useEffect, useState } from 'react';
import { useClient } from '../context/ClientContext';

function ClientDropdown(props) {
  const [query, setQuery] = useState('');
  const {clients} = useClient();
  
  const selectedClient = clients.find((c) => c.id === props.client) || null;
  const [selected, setSelected] = useState(selectedClient);
  
  useEffect(() => {
    setSelected(selectedClient); // Directly set the selected client from props
  }, [selectedClient]);

  const filteredClients =
    query === ''
      ? clients
      : clients.filter(
          (client) =>
            client?.client_name.toLowerCase().includes(query.toLowerCase())
        );

  const handleSelectChange = async (client) => {
    setSelected(client);
    // Call the parent's callback to send the selected client back
    if (props.onClientSelect) {
      props.onClientSelect(client);
    }
  };

  return (
    <Combobox
      value={selected}
      onChange={handleSelectChange}
      by={(a, b) => a?.client_name === b?.client_name} // Compare clients by name
    >
      <div className="relative">
        <div className="relative w-full">
          <ComboboxInput
            className="border border-gray-300 p-2 w-full rounded-md cursor-pointer mt-2"
            placeholder="Not Assigned"
            displayValue={(client) => client?.client_name || 'Not Assigned'}
            onChange={(event) => setQuery(event.target.value)}
          />
          <ComboboxButton className="absolute inset-y-0 right-0 flex items-center pr-2">
            <ChevronDownIcon className="h-5 w-5 text-gray-400" />
          </ComboboxButton>
        </div>

        <ComboboxOptions className="w-full absolute mt-1 bg-white shadow-lg max-h-60 rounded-md py-1 text-base ring-1 ring-black ring-opacity-5 overflow-auto focus:outline-none sm:text-sm cursor-pointer z-50">
          <ComboboxOption
            key={null}
            value={null}
            className={({ active, selected }) =>
              `cursor-pointer select-none relative py-2 pl-10 pr-4 ${
                active ? 'bg-indigo-600 text-white' : 'text-gray-900'
              } ${selected ? 'font-bold' : 'font-normal'}`
            }
          >
            <span className="block truncate">Not Assigned</span>
          </ComboboxOption>

          {filteredClients.length === 0 ? (
            <div className="px-4 py-2 text-gray-700">No results found.</div>
          ) : (
            filteredClients.map((client) => (
              <ComboboxOption
                key={client.id}
                value={client}
                className={({ active, selected }) =>
                  `cursor-pointer select-none relative py-2 pl-10 pr-4 ${
                    active ? 'bg-indigo-600 text-white' : 'text-gray-900'
                  } ${selected ? 'font-bold' : 'font-normal'}`
                }
              >
                <span className="block truncate">{client.client_name}</span>
              </ComboboxOption>
            ))
          )}
        </ComboboxOptions>
      </div>
    </Combobox>
  );
}

export default ClientDropdown;
